export const VERSION = "v1.1.0";
